import { useEffect, useState } from 'react';
import { Transition } from '@headlessui/react';
import clsx from 'clsx';
import { Card } from 'flowbite-react';
import get from 'lodash/get';
import moment from 'moment';
import Image from 'next/image';
import { HiOutlineBookmark, HiOutlineShare } from 'react-icons/hi';

import AgentContactInfo from 'components/elements/agentContactInfo';
import { Button } from 'components/elements/button';
import { observer } from 'mobx-react';
import Link from 'next/link';
import { Pricing } from "../../../../lib/apis/services/PdpSingle/type";
import HelperTranslate from "../../../../lib/utils/helpers/helperTranslate";
import { useContactInfo } from '../hooks/useContanctInfo';
import PropertyPricing from './propertyPricing';
import { useGetAllFavorite } from '../../../../lib/apis/services/plpCardAction/service';

interface Props {
    visiblePrice?: boolean;
}

function ContactInfo({ visiblePrice = false }: Props) {
    const {
        data,
        dynamicModel,
        favStatus,
        makeFav,
        saveListing,
        shareModal,
        t,
        identifier,
    } = useContactInfo();
    // const [favStatus, setFavStatus] = useState(false);
    const allData = data?.data.listing;
    const pdpContactInfo = data?.data.listing.agency;

    const pricing: Pricing = {
        price: allData?.priceOrDeposit,
        deposit: allData?.priceOrDeposit,
        rent: allData?.unitPriceOrRent,
        unitPrice: allData?.unitPriceOrRent,
        currency: "",
        agreedPrice: allData?.agreedPrice,
        depositOnly: allData?.depositOnly,
        capRatePercentage: 0,
        listingType: allData!.listingType
    }
    return (
        <div
            className="sticky hidden top-[152px] md:flex flex-col space-y-4"
            key={identifier}
        >
            <Card className="flex h-fit">
                <div className="-m-2">
                    <div className="flex flex-row space-x-2 rtl:space-x-reverse">
                        <Link
                            className="rounded-[2.5rem]"
                            prefetch={false}
                            href={pdpContactInfo?.agencyType !== "OWNER" ? `/real-estate-agencies/detail/${pdpContactInfo?.id}` : identifier}
                        >
                            {pdpContactInfo?.agencyType !== 'OWNER' ?(
                                <a>
                                    <Image
                                        src={(pdpContactInfo?.logo != null) ? pdpContactInfo.logo + '?q=large' : 'https://cdn.kilid.com/default-logo.png'}
                                        width={115}
                                        height={115}
                                        alt={pdpContactInfo!.name}
                                        placeholder='blur'
                                        blurDataURL='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcvgAAAfQBSWu8iX0AAAAASUVORK5CYII='
                                        onError={(err) => {
                                            err.currentTarget.src =
                                              'https://cdn.kilid.com/default-logo.png';
                                            err.currentTarget.srcset = '';
                                        }}
                                    />
                                </a>
                            ): (
                                <Image
                                    src={(pdpContactInfo?.logo != null) ? pdpContactInfo.logo + '?q=large' : 'https://cdn.kilid.com/default-logo.png'}
                                    width={115}
                                    height={115}
                                    alt={pdpContactInfo!.name}
                                    placeholder='blur'
                                    blurDataURL='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNcvgAAAfQBSWu8iX0AAAAASUVORK5CYII='
                                    onError={(err) => {
                                        err.currentTarget.src =
                                          'https://cdn.kilid.com/default-logo.png';
                                        err.currentTarget.srcset = '';
                                    }}
                                />
                            )
                            }
                        </Link>
                        <div className="h-[115px] flex flex-col justify-between">
                            <div className="flex flex-col">
                                {pdpContactInfo!.name && (
                                    <p className="font-bold">{pdpContactInfo!.name}</p>
                                )}
                                {pdpContactInfo!.agencyType && (
                                    <p>{pdpContactInfo!.agencyType ? t(`enums.agencyType.${pdpContactInfo!.agencyType}`, true) : ""}</p>
                                )}
                            </div>
                            <div className="flex flex-col">
                                <p className="text-sm">
                                    {t('plp.propertyInfo.listingId', true)}:{' '}
                                    {allData!.id}
                                </p>
                                <p className="text-sm">
                                    {
                                        get(allData, dynamicModel.date.path)
                                            ? moment(new Date(get(allData, dynamicModel.date.path))).fromNow()
                                            : dynamicModel.date.default
                                    }
                                    {/*{get(allData, dynamicModel.date.path)&& moment(new Date(get(allData, dynamicModel.date.path, dynamicModel.date.default))).fromNow()}*/}
                                </p>
                            </div>
                        </div>
                    </div>
                    <Transition
                        show={visiblePrice}
                        enter="transition-all ease duration-500 transform"
                        enterFrom="opacity-0 h-auto max-h-0"
                        enterTo="opacity-100 h-auto max-h-[300px]"
                        leave="transition-all ease duration-500 transform"
                        leaveFrom="opacity-100 h-auto max-h-[300px]"
                        leaveTo="opacity-0 h-auto max-h-0"
                    >
                        <div
                            className="flex flex-col justify-around flex-1 pt-4 pb-8 space-y-4 border-b border-grey-300">
                            <PropertyPricing pricing={pricing} forContactInfo />
                            <p className="w-full">
                                {get(
                                    allData,
                                    dynamicModel.location.locationName.path,
                                    dynamicModel.location.locationName.default
                                )}
                            </p>
                            <div className="w-full">
                                <ul className="flex flex-wrap gap-2">
                                    {dynamicModel.attributes.chips.map(
                                      (chipsItem, index) =>{
                                          const value = get(allData, chipsItem.path, chipsItem.default);
                                          return !!value && (
                                            <li
                                              key={`${chipsItem.path}-ch-${index}`}
                                              className="px-2 py-1 text-sm rounded-lg bg-grey-100"
                                            >
                                                {chipsItem.prefix ? `${chipsItem.prefix} ` : ''}
                                                {HelperTranslate(t,chipsItem.path, get(allData, chipsItem.path, chipsItem.default))}
                                                {chipsItem.suffix ? ` ${chipsItem.suffix}` : ''}
                                            </li>
                                          )
                                      }
                                    )}
                                </ul>
                            </div>
                        </div>
                    </Transition>

                    <div className="w-full mt-8">
                        <AgentContactInfo Identifier={identifier} className="w-full" fromPage="PDP" />
                    </div>
                </div>
            </Card>

            <div className="flex gap-2">
                <Button
                    variant="light"
                    className={clsx('space-x-4 rtl:space-x-reverse max-w-full', {
                        'text-grey-800': !favStatus && !makeFav.isLoading,
                        'text-grey-500 cursor-wait': !favStatus && makeFav.isLoading,
                        '!bg-primary-500 !text-white': favStatus,
                    })}
                    onClick={saveListing}
                >
                    <HiOutlineBookmark
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-5 h-5"
                    />
                    <span>{t('global.saved', true)}</span>
                </Button>
                <Button
                    variant="light"
                    className="max-w-full"
                    onClick={() => {
                        shareModal.openModal();
                    }}
                >
                    <HiOutlineShare
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-5 h-5 text-grey-800"
                    />
                    <span>{t('global.share', true)}</span>
                </Button>
            </div>

            {/*<AddSenseIns type="pdp-side" slot="1393662788" />*/}
        </div>
    );
}

export default observer(ContactInfo);
